import React, { useEffect, useState } from "react";

import { Tab, Tabs, Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import {
  AutoStories,
  ForumOutlined,
  Home,
  Redeem,
  Storefront,
} from "@mui/icons-material";

import ArtistFab from "@/components/ArtistFab";
import NotebookIcon from "@/fragments/NotebookIcon";
import { useArtist } from "@/services/hooks";
export default function BottomTabs() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const { artistKey } = useParams();
  const { data: artist } = useArtist(artistKey);
  const handleTabChange = (e, newValue) => {
    switch (newValue) {
      case 0:
        navigate(`/${artistKey}`);
        break;
      case 1:
        navigate(`/${artistKey}/notes`);
        break;
      case 2:
        navigate(`/${artistKey}/music`);
        break;
      case 3:
        navigate(`/${artistKey}/store`);
        break;
      case 4:
        navigate(`/${artistKey}/threads`);
        break;
    }
  };

  useEffect(() => {
    if (window.location.pathname === `/${artistKey}`) {
      setActiveTab(0);
    } else if (window.location.pathname === `/${artistKey}/notes`) {
      setActiveTab(1);
    } else if (window.location.pathname === `/${artistKey}/music`) {
      setActiveTab(2);
    } else if (window.location.pathname === `/${artistKey}/store`) {
      setActiveTab(3);
    } else if (window.location.pathname === `/${artistKey}/threads`) {
      setActiveTab(4);
    }
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  return (
    <Box sx={{ display: { xs: "block", lg: "none" } }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        slotProps={{
          indicator: {
            sx: { top: 0 },
          },
        }}
        textColor="inherit"
        variant="fullWidth"
        sx={{
          position: "fixed",
          bottom: 0,
          bgcolor: "rgba(18, 18, 18, 0.95)",
          left: "50%",
          transform: "translateX(-50%)",
          width: "100%",
          pt: 0,
          pb: 2,

          "& .MuiTab-root": {
            minWidth: "70px",
            height: "68px",
          },
        }}
      >
        <Tab icon={<Home />} sx={{ pt: 0 }} />
        <Tab icon={<AutoStories />} sx={{ pt: 0 }} />
        <Tab icon={<NotebookIcon size={24} />} sx={{ pt: 0 }} />
        <Tab icon={<Storefront />} sx={{ pt: 0 }} />
        {artist && artist?.meta?.threads != "Off" && (
          <Tab icon={<ForumOutlined />} sx={{ pt: 0 }} />
        )}
      </Tabs>
      <ArtistFab />
    </Box>
  );
}
